import React, { useContext, useState, useEffect } from 'react';
import MetricsFilterElements from './MetricsFilterElements';
import {    MetricsContainer, MetricsTitle, MetricsSearch, 
            Metrics, MetricsElement, FiltersTitle, MetricsFilterDroppable,
            FiltersTitleContainer, FiltersDropField, LimitMessage} from '../styles/containerComponents.styles';
import { ReactComponent as DragIcon } from '../assets/icons/dragIcon.svg'
import { ReactComponent as SearchIcon } from '../assets/icons/searchIcon.svg'
import { Droppable, Draggable } from 'react-beautiful-dnd'
import { ChartContext } from '../context/ChartContext'
import QuestionCounterElement from './QuestionCounter';
import { colorTeal, colorPurple, colorTealLight, colorPurpleLight } from '../styles/sharedStyles';

const FiltersContainer = () => {

    const { borderDroppable, metricQuestions, path,
            displayedMetrics, setDisplayedMetrics, filterQuestions, chartQuestions } = useContext(ChartContext)
    const [ searchValue, setSearchValue ] = useState('')

    useEffect(() => {
        
        const filteredMetricQuestions = metricQuestions.filter(q => 
            q.type.toLowerCase().includes(searchValue.toLowerCase()) 
            ||
            q.question.toLowerCase().includes(searchValue.toLowerCase()) 
        ) 
        setDisplayedMetrics(filteredMetricQuestions)
    }, [searchValue, metricQuestions, setDisplayedMetrics])

    useEffect(() => {
        const chartQids = chartQuestions.map(el => el.qid)
        const filterQids = filterQuestions.map(el => el.qid)
        const questionIds = [...chartQids, ...filterQids]
        const newDisplayedMetrics = metricQuestions.filter(el => !questionIds.includes(el.qid))
        setDisplayedMetrics([...newDisplayedMetrics])
    },[filterQuestions, chartQuestions])
    

    const respondentType = path === "hrds" ? "Human Rights Defender" : "Legal Experts"
    
    const questionsChips = displayedMetrics
        .filter(el => el.respondent === respondentType)
        .map((el, i) => (
            <Draggable
                draggableId={+el.qid}
                index={i}
                key={+el.qid}
            >
                {
                    (provided, snapshot) => (
                        <MetricsElement
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            color='#333'
                            chipColor={path === "hrds" ? colorTeal : colorPurple}
                            isDragging={snapshot.isDragging}
                        >
                                <div className="chip-head">
                            <DragIcon className="icon"/>
                                </div>
                                <div className="chip-content">
                                {el.question}
                                </div>
                        </MetricsElement>
                    )
                }
            </Draggable>
        ))


    return ( 
        <>
            <MetricsContainer
                data-tut="metrics-container"
            >
                <MetricsTitle>
                    Metrics
                </MetricsTitle>
                <MetricsSearch> 
                    <input 
                        type="text"
                        placeholder="Search for questions or question types..."
                        value={searchValue}
                        onChange={e => setSearchValue(e.target.value)}
                    />
                    <SearchIcon className="search-icon"/>
                </MetricsSearch>
                <Droppable
                    droppableId={1}
                >
                    {
                        (provided, snapshot) => (
                            <Metrics
                                {...provided.droppableProps} 
                                ref={provided.innerRef}
                                isDraggingOver={snapshot.isDraggingOver}
                            >
                                {questionsChips}
                                {provided.placeholder}
                            </Metrics>
                        )
                    }
                </Droppable>
            </MetricsContainer>

            <FiltersTitleContainer>
                <FiltersTitle>
                    Filters
                </FiltersTitle>
                <FiltersDropField>
                    <QuestionCounterElement
                        width={(filterQuestions.length/5 )* 100}
                        top={4.75}
                        color={path === "hrds" ? colorTeal : colorPurple}
                    />
                    {
                        filterQuestions.length < 5 
                            ?   <Droppable
                                    droppableId={2}
                                >
                                    {
                                        (provided, snapshot) => (
                                            <MetricsFilterDroppable
                                                {...provided.droppableProps} 
                                                ref={provided.innerRef}
                                                isDraggingOver={snapshot.isDraggingOver}
                                                justify="flex-end"
                                                border={borderDroppable}
                                                color={path === "hrds" ? colorTeal : colorPurple}
                                                lightColor={path === "hrds" ? colorTealLight : colorPurpleLight}
                                            >
                                                Drop a question here to use it as a filter!
                                            </MetricsFilterDroppable>
                                            
                                        )
                                    }
                                </Droppable>
                            :   <LimitMessage>
                                    You have reached the limit of filter questions!
                                </LimitMessage>
                    }
                </FiltersDropField>
            </FiltersTitleContainer>
                <MetricsFilterElements/>
        </>
     );
}
 
export default FiltersContainer;